import { Box, Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  inset?: boolean;
  children: ReactNode;
}

export const SettingsCard = ({
  title,
  subtitle,
  actions,
  inset = true,
  children,
}: Props) => (
  <Box
    mt="5"
    width="full"
    rounded="lg"
    borderWidth="1px"
    borderStyle="solid"
    borderColor="smBorder"
    overflow="hidden"
  >
    <Flex
      alignItems="center"
      justifyContent="space-between"
      gap="3"
      px="5"
      py="3"
      backgroundColor="smBackgroundSecondary"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderColor="smBorder"
    >
      <Flex alignItems="baseline" gap="3" minWidth="0">
        <Text fontWeight="semibold" whiteSpace="nowrap">
          {title}
        </Text>
        {subtitle && (
          <Text fontSize="sm" color="smMuted" isTruncated>
            {subtitle}
          </Text>
        )}
      </Flex>
      {actions && (
        <Flex alignItems="center" gap="2" flexShrink={0}>
          {actions}
        </Flex>
      )}
    </Flex>
    {inset ? (
      <Flex px="5" py="4" flexDir="column" gap="3">
        {children}
      </Flex>
    ) : (
      children
    )}
  </Box>
);
